var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgShoppingCart = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33915 8.55581L1.01562 4.23229L2.90124 2.34668L7.22476 6.6702H27.5471C28.2835 6.6702 28.8804 7.26716 28.8804 8.00353C28.8804 8.13329 28.8615 8.26237 28.8243 8.38667L25.6243 19.0533C25.4551 19.6173 24.9359 20.0036 24.3471 20.0036H8.00581V22.6703H22.6725V25.3369H6.67248C5.93609 25.3369 5.33915 24.7399 5.33915 24.0036V8.55581ZM8.00581 9.33687V17.3369H23.3551L25.7551 9.33687H8.00581ZM7.33915 30.6703C6.23457 30.6703 5.33915 29.7748 5.33915 28.6703C5.33915 27.5656 6.23457 26.6703 7.33915 26.6703C8.44372 26.6703 9.33915 27.5656 9.33915 28.6703C9.33915 29.7748 8.44372 30.6703 7.33915 30.6703ZM23.3392 30.6703C22.2345 30.6703 21.3392 29.7748 21.3392 28.6703C21.3392 27.5656 22.2345 26.6703 23.3392 26.6703C24.4437 26.6703 25.3392 27.5656 25.3392 28.6703C25.3392 29.7748 24.4437 30.6703 23.3392 30.6703Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShoppingCart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ShoppingCart.056d7dc1.svg";
export { ForwardRef as ReactComponent };